<template>
    <main class="login-form">
        <b-modal v-model="showLoginModal" id="modal-center" size="sm" centered title="VPPP auth">
            <p class="my-4">Please login with you valid credentials [{{ loginModalText }}].</p>
        </b-modal>

        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <div class="card">
                        <div class="card-header">Login to service</div>
                        <div class="card-body">
                            <form onsubmit="return false;">
                                <div class="form-group row">
                                    <label for="email_address" class="col-md-4 col-form-label text-md-right"
                                        >sonnen username</label
                                    >
                                    <div class="col-md-6">
                                        <input
                                            type="text"
                                            id="username"
                                            class="form-control"
                                            name="username"
                                            v-model="input.username"
                                            required
                                            autofocus
                                        />
                                    </div>
                                </div>

                                <div id="user_auth" class="form-group row">
                                    <label for="password" class="col-md-4 col-form-label text-md-right">Password</label>
                                    <div class="col-md-6">
                                        <input
                                            type="password"
                                            id="password"
                                            v-model="input.password"
                                            class="form-control"
                                            name="password"
                                            required
                                        />
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-md-6 offset-md-4">
                                        <div class="checkbox">
                                            <label>
                                                <input type="checkbox" name="remember" />
                                                Remember Me
                                            </label>
                                        </div>
                                    </div>

                                    <div class="col-md-6 offset-md-4">
                                        <button v-on:click="login('#user_auth')" class="btn btn-primary">Login</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: "LoginComponent",
    watch: {
        login: function (val) {
            this.showLoginModal = !val;
        }
    },
    data() {
        return {
            showLoginModal: false,
            loginModalText: "",
            input: {
                username: "",
                password: ""
            }
        };
    },
    computed: {},
    created() {},
    methods: {
        async login() {
            const { username, password } = this.input;
            const encryptedPassword = this.$CryptoJS.AES.encrypt(password, "process.env.KEY").toString();
            const api = this.$appConfig.AUTH_SERVER_URI;
            const config = {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            };
            const params = new URLSearchParams();
            params.set("username", username);
            params.set("password", password);
            this.$store.state.user.loggedIn = false;
            const url_params = decodeURIComponent(window.location.search).split("/");
            if (!this.$session.exists() && username && password) {
                await this.axios.post(api, params, config).then((response) => {
                    if ("success" in response.data) {
                        if (response.data.success) {
                            this.$store.state.user.loggedIn = true;

                            console.log("User authorized.", username);
                            this.$store.state.user.user = username;
                            this.$store.state.user.fullname = response.data.data.user_info.name;
                            this.$store.state.user.token = response.data.gitlab_token;
                            this.$session.start();
                            this.$session.set("username", username);
                            this.$session.set("fullname", response.data.data.user_info.name);
                            this.$session.set("encryptedPassword", encryptedPassword);
                            this.$session.set("token", response.data.gitlab_token);
                            this.$session.set("email", response.data.data.user_info.email);

                            if (url_params.length == 3) {
                                this.$router.go(url_params[1] + "/" + url_params[2]);
                            } else {
                                this.$router.go("/").catch(() => {});
                            }
                        } else {
                            console.log("not authorized!");
                            this.$store.state.user.loggedIn = false;
                            this.showLoginModal = true;
                            this.loginModalText = response.data.error_message;
                        }
                    } else {
                        console.log("login action error");
                        console.log(response);

                        this.$store.state.user.loggedIn = false;
                        this.showLoginModal = true;
                    }
                });
            } else {
                this.$router.push(url_params[1] + "/" + url_params[2]);
            }
        },
        logout() {
            console.log("logout", this.$session.id());
            this.$store.state.user.loggedIn = false;
            if (this.$session.exists) {
                this.$session.destroy();
            }
        },
        showModal() {
            this.$refs["modal-center"].show();
        }
    }
};
</script>

<style>
.my-form {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

.my-form .row {
    margin-left: 0;
    margin-right: 0;
}

.login-form {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

.login-form .row {
    margin-left: 0;
    margin-right: 0;
}
</style>
